import React, { useContext, useEffect } from 'react'
import { MessengerContext } from '../../context/MessengerContext'
import { AuthContext } from '../../context/AuthContext'

import './emptyStateConversation.css'

const EmptyStateConversation = () => {

  const {user} = useContext(AuthContext)

  const [conversation, setConversation] = useContext(MessengerContext)

  const PF = process.env.REACT_APP_PUBLIC_FOLDER

  const communicatorFriends = conversation?.communicator?.following || []

  const myFriends = user.following

  const mutualFriends = myFriends.filter((value) => communicatorFriends.includes(value))

  useEffect(() => {

  }, [conversation])

  return (
    <div className="emptyStateConversation">
        <div className="emptyStateConversationWrapper">
            <img src={conversation.communicator.profilePicture || (PF + "person/default_avatar.jpg")} alt="" className='esCommunicatorProfileImg'/>
            <p className='esUsername'>{conversation.communicator?.username}</p> 
            {
              myFriends.includes(conversation.communicator._id)
              ?
              <>
                <p className='esFriends'>You're friends on Bloom</p> 
                {
                  conversation.communicator.living_in_city && conversation.communicator.living_in_country
                  &&
                  <p className='esInfo'>Lives in {`${conversation.communicator.living_in_city}, ${conversation.communicator.living_in_country}`}</p>
                }
              </>   
              :
              (
                mutualFriends.length !== 0 &&
                <p className='esFriends'>{mutualFriends.length} mutual friends</p>    
              )
            }   
        </div>
    </div>
  )
}

export default EmptyStateConversation